import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import TagManager from "react-gtm-module";

/**
 * Custom hook to track page views in Google Tag Manager
 * Automatically sends pageview events when the route changes
 */
export const useGTMPageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Send page view event to GTM on route change
    TagManager.dataLayer({
      dataLayer: {
        event: "pageview",
        page: {
          path: location.pathname,
          search: location.search,
          hash: location.hash,
          url: window.location.href,
        },
      },
    });
  }, [location]);
};
